import React, { useEffect, useState } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import 'chart.js/auto';
import { vAPIURL, vGlobalDateNow } from '../../Global';
import axios from 'axios';
import toastr from 'toastr';
import format from 'date-fns/format';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(...registerables )

const BookingVsCheckin = () => {
	const [ Loading, setLoading ] = useState( false )
	const [ DataTemp, SetDataTemp ] = useState( [] );
	const date = new Date( vGlobalDateNow );

	let vNumberFormat = new Intl.NumberFormat(
		'en-US'
		, {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		}
	)

	const GetBookingVsCheckinData = async() => {
		setLoading( true );
		let vStatus = 1;
		let vMessage = [];

		try{
			const vURL = vAPIURL + "/Golf/Main/BookingVsCheckin/Dev";
			const vData = {
				Action: {
					Value: "Search"
				},
				Input: {
					Date: {
						Value: format( date, 'dd-MMM-yyyy' ),
					},
				},
			};
			const vConfig = {
				headers: {
					"Content-Type": "application/json"
					, Authentication: `${localStorage.getItem("Authentication")}`
				}
			}
			await axios
				.post( vURL, vData, vConfig )
				.then(
					( vResponse ) => {
						vStatus = vResponse.data.Status;

						for( let i = 0; i < vResponse.data.Message.length; i++ ){
							vMessage.push( vResponse.data.Message[ i ] );
						}

						if( vStatus === 1 ){
							SetDataTemp( vResponse.data.Output.Result )
						}
					}
				)
				.catch(
					( vError ) => {
						vStatus = 2;
						vMessage.push( "Error" );
					}
				)
		}catch( vError ){
			vStatus = 2;
			vMessage.push( "Error" );
		}

		if( vMessage.length > 0 ){
			if( vStatus === 1 ){
				//toastr.success( vMessage.join( "</br>" ) );
			}
			else{
				toastr.error( vMessage.join( "</br>" ) );
			}
		}
		setLoading( false );
	}

	let ChartData = {
		labels: DataTemp.map( Value => Value.Date ),
		datasets: [
			{
				label: 'BOOKING',
				data: DataTemp.map( Value => Value.Booking ),
				// KUNING CERAH (Terang - Teks akan otomatis gelap)
				backgroundColor: '#1E3A5F',
				borderColor: '#1E3A5F', 
				borderWidth: 1,
				stack: 1,
				order: 1
			},
			{
				label: 'CHECK-IN',
				data: DataTemp.map( Value => Value.Actual ),
				// HIJAU DAUN (Sedang - Teks akan otomatis terang/putih)
				backgroundColor: '#2E8B57', 
				borderColor: '#2E8B57',
				borderWidth: 1,
				stack: 2,
				order: 2
			},
			{
				label: 'CANCEL',
				data: DataTemp.map( Value => Value.Cancel ),
				// MERAH TUA/CRIMSON (Gelap - Teks akan otomatis terang/putih)
				backgroundColor: '#8B1E3F', 
				borderColor: '#8B1E3F', 
				borderWidth: 1,
				stack: 2,
				order: 2
			},
			{
				label: 'NO-SHOW',
				data: DataTemp.map( Value => Value.NoShow ),
				// UNGU/PURPLE (Gelap - Teks akan otomatis terang/putih)
				backgroundColor: '#C46A2D', 
				borderColor: '#C46A2D', 
				borderWidth: 1,
				stack: 2,
				order: 3
			},
			{
				label: 'RESCHEDULE',
				data: DataTemp.map( Value => Value.Reschedule ),
				// BIRU MUDA/CYAN (Terang - Teks akan otomatis gelap)
				backgroundColor: '#2A9D8F', 
				borderColor: '#2A9D8F',
				borderWidth: 1,
				stack: 2,
				order: 3
			},
			{
				label: 'AVERAGE ACTUAL',
				data: DataTemp.map( Value => Value.AverageActual ),
				// DEEP CHARCOAL/ABU-ABU GELAP (Garis pembeda yang netral)
				backgroundColor: '#5B6770', 
				borderColor: '#5B6770',
				type: 'line',
				order: 0,
				datalabels: {
				labels: {
					title: null
				}
				}
			}
		]
	}

	let ChartOption = {
		maintainAspectRatio: false
		, responsive : true
		, scales: {
			x: {
				beginAtZero: true,
			},
			y: {
				beginAtZero: true,
			},
		}
		, plugins: {
			legend: {
				display: true
				, position: 'top'
				, align: 'center'
				, labels: {
					boxHeight: 10
					, boxWidth: 10
					, textAlign: 'left'
				}
			}
			, tooltip: {
				callbacks: {
					title: function(tooltipItem, data) {
						return ''
					}
				}
			}
			, datalabels: {
				display: true
				, align: 'center'
				, anchor: 'center'
				, color: function(context) {
					const bgColors = context.dataset.backgroundColor;
					let color = Array.isArray(bgColors) ? bgColors[context.dataIndex] : bgColors;

					if (!color) return '#000000';

					let hex = color.replace('#', '');

					if (hex.length === 3) {
					hex = hex.split('').map(char => char + char).join('');
					}

					let r, g, b;
					if (color.startsWith('rgb')) {
						const match = color.match(/\d+/g);
						r = parseInt(match[0]);
						g = parseInt(match[1]);
						b = parseInt(match[2]);
					} else {
						r = parseInt(hex.substring(0, 2), 16);
						g = parseInt(hex.substring(2, 4), 16);
						b = parseInt(hex.substring(4, 6), 16);
					}

					const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

					return yiq > 128 ? '#222222' : '#FFFFFF';
				}
				, font: {
					size: 10
				}
			}
		}
		, onClick: (e, activeEls) => {
			window.location.href = '/Reservation'
		}
		, onHover: (e, ChartElement) => {
			e.native.target.style.cursor = ChartElement[0] ? 'pointer' : 'default'
		},
	}

	useEffect(() => {
		GetBookingVsCheckinData()
	},[])

	return (
		<div className="col-12 col-md-6">
			<div className="card bg-gradient-light">
				<div className="card-header">
					<h3 className="card-title text-success font-weight-bold">
						BOOKING VS NO-SHOW
					</h3>
					<div className="card-tools">
						<ul className="nav nav-pills ml-auto">
							<li className="nav-item text-info font-weight-bold">
							</li>
						</ul>
					</div>
				</div>
				<div className="CardBody-Chart">
					<div className="tab-content p-0">
						{
							Loading ?
								<div className="d-flex justify-content-center">
									<i className="fas fa-3x fa-sync-alt fa-spin"/>
								</div>
							:
								<div className="Chart-Container">
									<Bar
										data={ChartData}
										plugins={[ChartDataLabels]}
										options={ChartOption}
										height={null}
										width={null}
									/>
								</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default BookingVsCheckin